import {$authHost, $host} from "./index";

export const fetchPublicNews = async (params = {}) => {
    const {data} = await $host.get('api/public-news', {params});
    return data;
};

export const fetchPublicNewsBySlug = async (slug) => {
    const {data} = await $host.get(`api/public-news/${encodeURIComponent(slug)}`);
    return data;
};

export const fetchAdminPublicNews = async (params = {}) => {
    const {data} = await $authHost.get('api/public-news/admin', {params});
    return data;
};

export const fetchAdminPublicNewsById = async (id) => {
    const {data} = await $authHost.get(`api/public-news/admin/${id}`);
    return data;
};

export const createAdminPublicNews = async (payload) => {
    const {data} = await $authHost.post('api/public-news/admin', payload);
    return data;
};

export const updateAdminPublicNews = async (id, payload) => {
    const {data} = await $authHost.put(`api/public-news/admin/${id}`, payload);
    return data;
};

export const archiveAdminPublicNews = async (id) => {
    const {data} = await $authHost.delete(`api/public-news/admin/${id}`);
    return data;
};

export const uploadAdminPublicNewsImage = async (formData) => {
    const {data} = await $authHost.post('api/public-news/admin/upload-image', formData);
    return data;
};
